import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './ListPage.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

function timeAgo(dateStr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (days < 1) return 'Hari ini';
  if (days < 30) return `${days} hari lalu`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} bulan lalu`;
  return `${Math.floor(months / 12)} tahun lalu`;
}

export default function VideoList() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeVideo, setActiveVideo] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_BASE}/videos/public/all`)
      .then((res) => setVideos(res.data.data || []))
      .catch(() => setVideos([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="list-page">
      <nav className="list-page__nav">
        <Link to="/" className="list-page__back">← Beranda</Link>
      </nav>

      <h1 className="list-page__title">Semua Video</h1>

      {loading ? (
        <p className="list-page__empty">Memuat...</p>
      ) : videos.length === 0 ? (
        <p className="list-page__empty">Belum ada video.</p>
      ) : (
        <div className="list-page__grid">
          {videos.map((v) => (
            <button key={v.id} className="list-card list-card--video" onClick={() => setActiveVideo(v.youtube_video_id)}>
              <div className="list-card__photo">
                <img
                  src={v.thumbnail_url || `https://img.youtube.com/vi/${v.youtube_video_id}/hqdefault.jpg`}
                  alt={v.title}
                  loading="lazy"
                />
                <span className="list-card__play">▶</span>
              </div>
              <div className="list-card__body">
                <p className="list-card__date">
                  {v.artist_name ? `${v.artist_name} · ` : ''}{timeAgo(v.published_at)}
                </p>
                <h3 className="list-card__title">{v.title}</h3>
              </div>
            </button>
          ))}
        </div>
      )}

      {activeVideo && (
        <div className="video-modal" onClick={() => setActiveVideo(null)}>
          <div className="video-modal__frame" onClick={(e) => e.stopPropagation()}>
            <iframe
              src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`}
              title="Video player"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
            <button className="video-modal__close" onClick={() => setActiveVideo(null)}>✕</button>
          </div>
        </div>
      )}
    </div>
  );
}
